import {
  Directive,
  Input,
  ElementRef,
  OnInit,
  OnDestroy,
  inject,
} from '@angular/core';
import { TourService } from '../../core/services/tour.service';
import { TourStepId } from '../../core/models/enums/tour-step-id.enum';
import { TourPopoverPosition } from '../../core/models/types/tour-popover-position.type';

@Directive({
  selector: '[tourStep]',
  standalone: true,
})
export class TourStepDirective implements OnInit, OnDestroy {
  @Input() tourStep!: TourStepId;
  @Input() tourPopoverPosition?: TourPopoverPosition;

  private readonly tourService = inject(TourService);
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  ngOnInit(): void {
    this.tourService.registerStep(
      this.tourStep,
      this.elementRef,
      this.tourPopoverPosition,
    );
  }

  ngOnDestroy(): void {
    this.tourService.unregisterStep(this.tourStep, this.elementRef);
  }
}
